import { render } from "./InfoContainer.vue?vue&type=template&id=ca07b3ce&scoped=true"
import script from "./InfoContainer.vue?vue&type=script&lang=js"
export * from "./InfoContainer.vue?vue&type=script&lang=js"

import "./InfoContainer.vue?vue&type=style&index=0&id=ca07b3ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca07b3ce"]])

export default __exports__